/* Layout only. Does not read or change the Shopify cart, tracking, or page URL. */
(() => {
  'use strict';
  const root = document.querySelector('[data-dsp-assistant-root]');
  if (!root || root.dataset.dspDawnReady) return;
  root.dataset.dspDawnReady = 'true';
  const mobile = window.matchMedia('(max-width: 600px)');
  let action;
  let resizeObserver;
  let mutationObserver;
  let pending = 0;
  function update() {
    pending = 0;
    const visible = mobile.matches && action?.isConnected &&
      action.classList.contains('is-visible') && !action.classList.contains('is-suppressed') &&
      getComputedStyle(action).display !== 'none' && !action.hidden;
    if (visible) {
      // The measured height already includes the phone's safe-area inset.
      root.style.setProperty('--dsp-dawn-launcher-clearance', `${Math.ceil(action.getBoundingClientRect().height) + 16}px`);
    } else {
      root.style.removeProperty('--dsp-dawn-launcher-clearance');
    }
  }
  function schedule() {
    if (!pending) pending = requestAnimationFrame(update);
  }
  function connect() {
    resizeObserver?.disconnect();
    mutationObserver?.disconnect();
    action = document.querySelector('[data-evtol-mobile-action]');
    if (action) {
      mutationObserver = new MutationObserver(schedule);
      mutationObserver.observe(action, { attributes: true, attributeFilter: ['class', 'hidden'] });
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(action);
      }
    }
    schedule();
  }
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  connect();
})();
